module.exports = __webpack_public_path__ + "img/tp-3.6fec09dd.png";